// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3TXDf","sendOtp":"AuthorizeToLogin_sendOtp__1VIiv"};